import yup from '../../../config/yup';

export const docuSignReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('docuSignReader'),
  delayedRead: yup.boolean(),
  parameterizedBy: yup.string().transform((value) => value.trim()),
  format: yup.string().transform((value) => value.trim()),
  connectionKey: yup.string().transform((value) => value.trim()),
  properties: yup.object().shape({
    debug: yup.boolean(),
    useBearerToken: yup.boolean(),
    basePath: yup.string().transform((value) => value.trim()),
    username: yup.string().transform((value) => value.trim()),
    password: yup.string().transform((value) => value.trim()),
    integratorKey: yup.string().transform((value) => value.trim()),
    accountId: yup.string().transform((value) => value.trim()),
    resourceType: yup.string().transform((value) => value.trim()),
    // YYYY-MM-DD
    fromDate: yup.string().transform((value) => {
      if (value && value.includes('/')) {
        const dateArr = value.split('/');
        return `${dateArr[2]}-${dateArr[0]}-${dateArr[1]}`;
      }
      return value;
    }),
    envelopeIds: yup.string().transform((value) => value.trim()),
    transactionIds: yup.string().transform((value) => value.trim()),
    folderIds: yup.string().transform((value) => value.trim()),
    include: yup.string().transform((value) => value.trim()),
    searchText: yup.string().transform((value) => value.trim()),
  }),
});
